// El bloque «Rentabilidad» de la banda «Usa tu IA» (Economía del cliente, copy §7).
//
// Los prompts de rentabilidad (tag `rentabilidad` del catálogo) usan el margen cargado en Dashbo:
// se juntan en su propio bloque SÓLO cuando el cliente lo tiene (`margen` entre los ingredientes
// disponibles). Salen de la biblioteca de abajo para no mostrarse dos veces — mismo criterio que el
// prompt sugerido, que tampoco se repite en las listas.

import {ING_MARGEN} from './useClientPromptLibrary';
import {isPromptEnabled, pickSuggestedPrompt} from './PromptPanelCard';

export const PROFITABILITY_TAG = 'rentabilidad';

export function isProfitabilityPrompt(prompt) {
    return !!prompt && Array.isArray(prompt.tags) && prompt.tags.includes(PROFITABILITY_TAG);
}

/**
 * `{profitability, rest}`: los prompts del bloque (habilitados, con el tag, sin el sugerido) y la
 * biblioteca sin ellos. Sin `margen` disponible el bloque va vacío y la biblioteca queda intacta.
 */
export function splitProfitability(prompts, available) {
    const list = prompts || [];
    const hasMargin = Array.isArray(available) && available.includes(ING_MARGEN);
    if (!hasMargin) return {profitability: [], rest: list};
    const suggested = pickSuggestedPrompt(list);
    const profitability = list.filter((prompt) => isProfitabilityPrompt(prompt) && isPromptEnabled(prompt)
        && (!suggested || prompt.id !== suggested.id));
    const ids = new Set(profitability.map((prompt) => prompt.id));
    return {profitability, rest: list.filter((prompt) => !ids.has(prompt.id))};
}
